import { useField } from 'formik';
import { NoOptionsMessage } from '@/components/select';
import { fetchSelectOptions } from '../../helpers/formHelpers';

export const useCreatableSelectHelpers = ({
  item,
  setSelected,
  setIsLoading,
}) => {
  const {
    name,
    isMulti,
    createConfig,
    customFormatLabel,
    customNoOptionsMessage,
    validateNewOption = () => true,
    createValueFromApi = false,
    createKey = 'name',
    validationType,
    labelKey = 'label',
    customOnChange,
    customOnCreate,
  } = item;

  const [_field, meta, helpers] = useField(name); // eslint-disable-line
  const { setValue, setTouched, setError } = helpers;

  const onChange = (selected) => {
    setSelected(selected);
    if (isMulti) {
      setValue(selected?.map((item) => item?.value));
    } else {
      setValue(selected?.value);
    }
    if (validationType === 'object') {
      setValue(selected);
    }
    customOnChange?.(selected);
    setTouched(true);
    setError(null);
    document
      .querySelector('.asyncCreateableField__value-container')
      ?.scrollIntoView({ behavior: 'smooth', block: 'end' });
  };

  const onCreate = async (inputValue) => {
    // Guard against creating options with empty values
    if (!inputValue || inputValue.trim() === '') {
      return;
    }

    try {
      setIsLoading(true);
      // Fetch options or prepare new value based on conditions
      let newValue;
      if (customOnCreate) {
        newValue = customOnCreate(inputValue);
      } else if (createValueFromApi) {
        newValue = await fetchSelectOptions({
          ...createConfig,
          payload: { [createKey]: inputValue },
        });
      } else {
        newValue = { label: inputValue, value: inputValue };
        // newValue = { label: inputValue, value: '__new__' };
      }

      if (isMulti) {
        setSelected((prev) => {
          if (prev?.length) return [...prev, newValue];
          else return [newValue];
        });
        setValue([...(meta?.value || []), inputValue]);
      } else {
        setSelected(newValue);
        setValue(newValue?.value);
      }
      customOnChange?.(newValue);
      setTouched(true);
      setError(null);
    } catch (error) {
      console.error('Error:', error);
    } finally {
      setIsLoading(false);
    }
  };

  const formatOptionLabel = (option) => {
    if (option.__isNew__) {
      return option?.label;
    } else if (customFormatLabel)
      return customFormatLabel(option, labelKey, item);
    return option?.label;
  };

  const isValidNewOption = (inputValue, value, options) => {
    const isOptionExist = options.some((item) => item.value === inputValue);

    if (isOptionExist) {
      return null;
    }

    const isValid = validateNewOption(inputValue);

    if (isValid) {
      return inputValue;
    }

    return undefined;
  };

  const NoOptionsMessageComp = (props) => {
    if (customNoOptionsMessage) return customNoOptionsMessage(props);
    return NoOptionsMessage(props);
  };

  return {
    onChange,
    onCreate,
    formatOptionLabel,
    isValidNewOption,
    NoOptionsMessageComp,
  };
};
